import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import PillPresenter from "presenters/PillPresenter";
import Placeholder from "components/Placeholder";

import useStyles from "./useStyles";

const Pill = ({ item, loading = false }) => {
  const classes = useStyles();

  if (loading)
    return (
      <div className={classes.category}>
        <Placeholder variant="rect" ratio="4x3" />
      </div>
    );

  return (
    <NavLink to={PillPresenter.url(item)}>
      <div className={classes.category}>
        <img src={PillPresenter.desktopImage(item)} alt={PillPresenter.name(item)} className={classes.image} />
      </div>
    </NavLink>
  );
};

Pill.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  loading: PropTypes.bool,
};

export default Pill;
